import { render, staticRenderFns } from "./TweenPrice.vue?vue&type=template&id=06e299bd&"
import script from "./TweenPrice.vue?vue&type=script&lang=js&"
export * from "./TweenPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports